import { FC, useCallback, useMemo } from 'react'

import { useFormField } from 'cng-common/features/form'

import { PARTNER_BASIC_INFO_FORM_KEY } from '../../../../../configs'
import { DEFAUT_ADDITIONAL_ITEM, DEFAUT_SUMMARY_ITEMS, SPLIT_CHARACTER } from '../../configs'
import { IMultiLinesItem, MultiLinesControl } from '../multiLinesControl/MultiLinesControl'

interface IFormSummaryInputsProps {
  field: string
  initialValue: string
}

export const FormSummaryInputs: FC<IFormSummaryInputsProps> = ({ field, initialValue }) => {
  const { value, handleChange } = useFormField({
    defaultValue: initialValue,
    formKey: PARTNER_BASIC_INFO_FORM_KEY,
    field,
  })

  const editableItems: IMultiLinesItem[] = useMemo(() => {
    const values = (value ?? '').split(SPLIT_CHARACTER)

    const items: IMultiLinesItem[] = []
    DEFAUT_SUMMARY_ITEMS.forEach((defaultItem, index) => {
      const value = values.length && values.length > index ? values[index] : defaultItem.value
      items.push({ ...defaultItem, value })
    })

    if (values.length && values.length > DEFAUT_SUMMARY_ITEMS.length) {
      const defaultItemsLength = DEFAUT_SUMMARY_ITEMS.length
      values.forEach((value, index) => {
        if (index >= defaultItemsLength) {
          items.push({ ...DEFAUT_ADDITIONAL_ITEM, value })
        }
      })
    }

    return items
  }, [value])

  const minLen = useMemo(() => {
    return DEFAUT_SUMMARY_ITEMS.length
  }, [])

  const maxLen = useMemo(() => {
    return DEFAUT_SUMMARY_ITEMS.length + 3
  }, [])

  const handleValuesChange = useCallback(
    (items: IMultiLinesItem[]) => {
      handleChange(items.map((el) => el.value).join(SPLIT_CHARACTER))
    },
    [handleChange]
  )

  return (
    <MultiLinesControl
      items={editableItems}
      onChange={handleValuesChange}
      minLen={minLen}
      maxLen={maxLen}
    />
  )
}
